var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"gradient-ripple-btn",class:{ [_vm.extra_class]: !!_vm.extra_class },on:{"click":_vm.handleButtonClick}},[_c('div',{staticClass:"ripple-wrapper",attrs:{"id":"ripple-container"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }